<style scoped>
.mu-input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  min-height: 0px;
  font-size: 12px;
  width: auto;
}
.focus-text {
  font-size: 24px;
}
.table-empty {
  text-align: center;
}
</style>

<template>
  <mu-card v-loading="loading">
    <mu-row>
      <mu-col span="6">
        <chart :option="pie" id="Popular" height="300px" />
      </mu-col>
      <mu-col span="6">
        <mu-data-table :columns="columns" :data="computedData">
          <template slot-scope="scope">
            <td><a :href="'/media/' + scope.row.media._id" target="_blank">{{scope.row.media.name}}</a></td>
            <td>{{scope.row.users}}</td>
            <td>{{scope.row.views}}</td>
          </template>
          <template slot="empty">
            <div class="table-empty">
              <small>{{$t('AnalyticsPopular.empty')}}</small>
            </div>
          </template>
        </mu-data-table>
      </mu-col>
    </mu-row>
    <mu-divider v-if="computedData.length <= 0"/>
    <mu-card-text>
      <mu-select v-model="modelDays">
        <mu-option v-for="(option, index) in optionsDays" :key="index" :label="option.text" :value="option.value"></mu-option>
      </mu-select>
    </mu-card-text>
  </mu-card>
</template>

<script>
import axios from "axios";

import theme from '@/mixins/theme.js'

import chart from '@/components/Charts/Charts.vue'
import echarts from 'echarts'

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  name: "AnalyticsPopular",
  props: ["channel"],
  mixins: [theme],
  components: {
    chart
  },
  data() {
    return {
      data: [],
      modelDays: 7,
      
      loading: false,
      
      ready: false,
    };
  },
  watch: {
    channel(newValue) {
      this.getData(newValue._id);
    },
    modelDays() {
      this.getData(this.channel._id);
    },
  },
  computed: {
    pie() {
      return {
        title: {
          text: this.$t('AnalyticsPopular.display'),
          left: 'center',
          top: 20,
          textStyle: {
            color: this.themeTextColor
          }
        },
        tooltip : {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          {
            name: this.$t('AnalyticsPopular.views'),
            type: 'pie',
            radius: '55%',
            center: ['50%', '50%'],
            data: this.computedData.map(i => {
              return {
                value: i.views,
                name: i.media.name
              }
            }).sort(function (a, b) { return a.value - b.value; }),
            label: {
              normal: {
                textStyle: {
                  color: 'rgba(255, 255, 255, 0.3)'
                }
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.3)'
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              }
            }
          }
        ],
      };
    },
    days() {
      return [3, 7, 14, 28, 30, 60, 90, 180, 360];
    },
    optionsDays() {
      return this.days.map(d => {
        return { text: this.$t('AnalyticsPopular.days.display', { num: d }), value: d }
      }).concat({ text: this.$t('AnalyticsPopular.days.all'), value: 0 });
    },
    columns() {
      return [
        { title: this.$t('AnalyticsPopular.media'), name: 'media', sortable: false },
        { title: this.$t('AnalyticsPopular.users'), name: 'users', sortable: false, width: 100 },
        { title: this.$t('AnalyticsPopular.views'), name: 'views', sortable: false, width: 100 },
      ]
    },
    computedData() {
      if(this.data.length > 0) {
        return this.data.filter(i => i.users !== 0 && i.views !== 0).sort((a, b) => a - b);
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  methods: {
    getData() {
      this.loading = true;
      axios
        .get(this.$store.getters.urlApi + "analytics/popular/channel/" + this.channel._id + '?days=' + this.modelDays, {
          headers: {
            token: this.$store.state.auth.token
          }
        })
        .then(response => {
          this.data = response.data.data.data;
          this.loading = false;
        });
    },
  },
};
</script>
